import { Box, Button, Container, Grid, Link, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { useInputStyles } from '../../../shared/components/UploadStyles';
import React from 'react';
import { BasicPage } from '../../../shared/components/BasicPage';
import { HomeContext } from '../../Home/HomeContext';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { AuthContext } from '../../Authentication/AuthContext';
import FAQ from '../../../assets/Clients/Ambev/faq.pdf';
import FAQBOT from '../../../assets/Clients/Boticario/faq.pdf';
import InfluencerWelcomeMessage from '../components/InfluencerWelcomeMessage';
import InfluencerICEHomeItens from '../components/InfluencerICEHomeItens';
import InfluencerHomeItensLegacy from '../components/InfluencerHomeItensLegacy';

export default function InfluencerHome() {
    const classes = useInputStyles();
    const homeContext = React.useContext(HomeContext);
    const authContext = React.useContext(AuthContext);
    const clientEnable = homeContext.influencerClientEnable;


    return (
        <>
            {clientEnable ? (
                <>
                    {clientEnable.nome.toLowerCase().includes('ambev') ? (
                        <InfluencerHomeItensLegacy />
                    )
                        : (
                            <InfluencerICEHomeItens />
                        )}
                </>
            ) : (<></>)}
        </>
    );
}